/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const taxIdDataVerificationSchema = z.enum(['pending', 'unavailable', 'unverified', 'verified'])

export type TaxIdDataVerificationSchema = z.infer<typeof taxIdDataVerificationSchema>
